import { render, staticRenderFns } from "./TopPostsByFollowers.vue?vue&type=template&id=006e1470&"
import script from "./TopPostsByFollowers.vue?vue&type=script&lang=js&"
export * from "./TopPostsByFollowers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports